import React from 'react';

interface CardProps {
  children:   React.ReactNode;
  className?: string;
  padding?:   'none' | 'sm' | 'md' | 'lg';
}

/** White surface, hairline border, no shadow. */
export const Card: React.FC<CardProps> = ({ children, className = '', padding = 'md' }) => {
  const pad = padding === 'none' ? '' : padding === 'sm' ? 'p-4' : padding === 'lg' ? 'p-6' : 'p-5';
  return <div className={`bg-white rounded-lg border border-stone-200 ${pad} ${className}`}>{children}</div>;
};
